export const initialApartments = {
  2: {
    floor: 2,
    building: 'A',
    apartmentNumber: 'A001',
    sceneName: 'scene_02krs_A001',
    sceneName_future: 'scene_02krs_A001_future',
    name: 'A001',
    label: 'A1',
    lookAt: '-20.34, 0, 120',
    face: 'south-west',

    relatedApartments: {
      3: 'A007',
    },
  },
  3: {
    floor: 3,
    building: 'A',
    apartmentNumber: 'A005',
    sceneName: 'scene_03krs_A005',
    sceneName_future: 'scene_03krs_A005_future',
    name: 'A005',
    label: 'A5',
    lookAt: '-133.71, 0, 120',
    face: 'south',

    relatedApartments: {
      2: 'A001',
      4: 'A011',
    },
  },
  4: {
    floor: 4,
    building: 'A',
    apartmentNumber: 'A011',
    sceneName: 'scene_04krs_A011',
    sceneName_future: 'scene_04krs_A011_future',
    name: 'A011',
    label: 'A11',
    lookAt: '-209.68, 0, 120',
    face: 'south',

    relatedApartments: {
      3: 'A005',
      5: 'A015',
    },
  },
  5: {
    id: 'A015',
    status: 'available',
    floor: 5,
    building: 'A',
    apartmentNumber: 'A015',
    sceneName: 'scene_05krs_A015',
    sceneName_future: 'scene_05krs_A015_future',
    name: 'A015',
    label: 'A15',
    lookAt: '-209.68, 0, 120',
    face: 'south',

    relatedApartments: {
      4: 'A011',
      6: 'B024',
    },
  },
  6: {
    id: 'B024-1',
    status: 'available',
    floor: 6,
    building: 'A',
    apartmentNumber: 'B024-1',
    sceneName: 'scene_06krs_B024-1',
    sceneName_future: 'scene_06krs_B024-1_future',
    name: 'B024-1',
    label: 'B24-1',
    lookAt: '-209.68, 0, 120',
    face: 'south',

    relatedApartments: {
      5: 'A016',
      7: 'B026',
    },
  },
  7: {
    id: 'B026',
    status: 'available',
    floor: 7,
    building: 'A',
    apartmentNumber: 'B026',
    sceneName: 'scene_07krs_B026',
    sceneName_future: 'scene_07krs_B026_future',
    name: 'B026',
    label: 'B26',
    lookAt: '-133.71, 0, 120',
    face: 'south-west',

    relatedApartments: {
      6: 'B024-1',
      8: 'C054',
    },
  },
  8: {
    id: 'C054-1',
    status: 'available',
    floor: 8,
    building: 'A',
    apartmentNumber: 'C054-1',
    sceneName: 'scene_08krs_C054-1',
    sceneName_future: 'scene_08krs_C054-1_future',
    name: 'C054-1',
    label: 'C54-1',
    lookAt: '-133.71, 0, 120',
    face: 'south-west',

    relatedApartments: {
      7: 'B026',
      9: 'C058',
    },
  },
  9: {
    id: 'C058',
    status: 'available',
    floor: 9,
    building: 'A',
    apartmentNumber: 'C058',
    sceneName: 'scene_09krs_C058',
    sceneName_future: 'scene_09krs_C058_future',
    name: 'C058',
    label: 'C58',
    lookAt: '-118.73, 0, 120',
    face: 'south-west',

    relatedApartments: {
      8: 'C054-1',
      9: 'C057-1',
    },
  },
  10: {
    id: 'C056',
    status: 'available',
    floor: 10,
    building: 'A',
    apartmentNumber: 'C056',
    sceneName: 'scene_10krs_C056',
    sceneName_future: 'scene_10krs_C056_future',
    name: 'C056',
    label: 'C56',
    lookAt: '-118.73, 0, 120',
    face: 'south-west',

    relatedApartments: {
      9: 'C058',
    },
  },
}
